import { DependencyList, useEffect } from 'react';

const useWindowResizeEffect = (
  onResize: () => void,
  deps?: DependencyList | undefined,
  cleanUp: () => void = () => {},
) => {
  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      if (cleanUp) {
        cleanUp();
      }
    };
  }, deps);
};

export default useWindowResizeEffect;
